<div class="kt-subheader kt-grid__item">
    <div class="kt-subheader__main">
        <h3 class="kt-subheader__title cursor-pointer" *ngIf="orderGuide && orderGuide.name || category && category.name">
            <p-breadcrumb [model]="navItems" [home]="home"></p-breadcrumb>
        </h3>
    </div>
    <div class="kt-subheader__toolbar">
        <div class="kt-subheader__wrapper">
            <button class="btn btn-primary" (click)="goToBasket()">
                <span translation="Axilla.PunchOut.BasketOverview" source="Axilla"></span>
            </button>
        </div>
    </div>
</div>

<div class="kt-content distribution feed">
    <div class="kt-portlet feed">
        <div class="kt-portlet__body feed" style="padding:0px">

            <app-data-view [items]="favoritesArticle"
                           [total]="favoritesItemsCount"

                           [category]="category"

                           [isSortingAvailable]="false"
                           [sortOptions]="sortOptions"

                           (openDetails)="openDetails($event)"
                           (searchAndLoadData)="searchAndLoadData($event)">
            </app-data-view>

            <div class="spinner-container" *ngIf="isLoading">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>

        <webshopItemDetails #webshopItemDetails
                            (addItemToBasket)="addToBasket($event, $event)"></webshopItemDetails>
    </div>
</div>

